/* eslint react/no-multi-comp: 0, react/prop-types: 0 */
// eslint-disable-next-line
import React, { useState, useEffect } from 'react';
import { Row, Col, Button, Modal, ModalHeader, ModalBody, ModalFooter, Form } from 'react-bootstrap';
import { copiriPortalRequest, parseDateString } from '../api/api'; // eslint-disable-next-line
import config from '../config/config'; // eslint-disable-next-line
import { toast } from 'react-toastify'; // eslint-disable-next-line
import Datetime from 'react-datetime';
import './profile_modal.css';
import { genPageData } from '../langconfig/langconfig'; // eslint-disable-next-line
const EditProfileDateModal = props => {
	// eslint-disable-next-line
	const { data, type, pageLanguageContent, dateGenderType, copiriGenderList, inputField, setInputField, dob } = props;
	const [date, setDate] = useState();
	const [validation, setValidation] = useState({
		error_date: '',
		error_gender: ''
	});
	const [disableSubmitButton, setDisableSubmitButton] = useState(false);
	useEffect(() => {
		if (data && props.showHide) {
			let initialsErrors = { ...validation };
			if (data.birthdate) {
				setDate(data.birthdate);
			}
			setValidation(initialsErrors);
		}
		// eslint-disable-next-line
	}, [props]);

	/* function to check the value of date input box  */
	const onChangeDate = event => {
		setDate(event.target.value);
	};

	const inputsHandler = e => {
		setInputField({ ...inputField, [e.target.name]: e.target.value });
		if (dateGenderType && dateGenderType === 'gender') {
			let index = e.nativeEvent.target.selectedIndex;
			let gender = e.nativeEvent.target[index].text;
			let gender_id = e.target.value;
			setInputField({ ...inputField, gender, gender_id });
		}
	};

	function updateProfileName() {
		let errors = { ...validation };
		var errorCount = 0;
		//first name validation
		if (dateGenderType && dateGenderType === 'dob') {
			if (!date) {
				errors.error_date = pageLanguageContent['PRL026'];
				errorCount++;
			} else {
				errors.error_date = '';
			}
		}
		if (dateGenderType && dateGenderType === 'gender') {
			if (!inputField.gender_id) {
				errors.error_gender = pageLanguageContent['PRL026'];
				errorCount++;
			} else {
				errors.error_gender = '';
			}
		}
		setValidation(errors);
		if (errorCount <= 0) {
			setDisableSubmitButton(true);
			var sendFormData = {};
			if (dateGenderType && dateGenderType === 'dob') {
				if (date) {
					let d = parseDateString(date);
					let mydate = d.toLocaleDateString('en-US');
					sendFormData['birthdate'] = mydate;
				}
			}
			if (dateGenderType && dateGenderType === 'gender') {
				if (inputField['gender_id']) {
					sendFormData['gender_id'] = inputField['gender_id'];
				}
			}
			copiriPortalRequest('/users/' + data['id'], config.app_version, 'patch', sendFormData)
				.then(response => {
					setDisableSubmitButton(false);
					if (response.status && response.status === 200) {
						toast.success(genPageData['GENDUS'] ? genPageData['GENDUS'] : '');
						props.onClick();
						props.updateModal(type, data['id'], inputField, date);
					}
				})
				.catch(error => {
					setDisableSubmitButton(false);
				});
		}
	}
	// eslint-disable-next-line
	function renderInput(props, openCalendar, closeCalendar) {
		return (
			<div>
				<input {...props} />
				<i
					className='far fa-calendar'
					style={{ position: 'absolute', right: '10px', top: '10px', cursor: 'pointer' }}
					onClick={openCalendar}
				></i>
			</div>
		);
	}

	return (
		<>
			<Modal show={props.showHide} onHide={props.onClick}>
				<ModalHeader
					onHide={props.onClick}
					style={{ backgroundColor: '#337ab7', border: '#337ab7' }}
					className='modalHeader'
				>
					<Modal.Title>{pageLanguageContent['PRL041'] ? pageLanguageContent['PRL041'] : ''}</Modal.Title>
				</ModalHeader>
				<ModalBody>
					{dateGenderType && dateGenderType === 'dob' && (
						<Row className='userProfileDateBirth'>
							<Col lg={12}>
								<Form.Group className='form-group'>
									<Form.Label for='dob'>
										{pageLanguageContent['PRL145'] ? pageLanguageContent['PRL145'] : ''}
									</Form.Label>
									<input
										type='date'
										placeholder=''
										value={date}
										className={'edit_user_dob form-control'}
										onChange={onChangeDate}
									/>
								</Form.Group>
								{validation.error_date && <p className='formValidationError'>{validation.error_date}</p>}
							</Col>
						</Row>
					)}
					{dateGenderType && dateGenderType === 'gender' && (
						<Row className='userProfileDateBirth'>
							<Col lg={12}>
								<Form.Group className='form-group'>
									<Form.Label for='gender'>
										{pageLanguageContent['PRL144'] ? pageLanguageContent['PRL144'] : ''}
									</Form.Label>
									<select
										id='gender'
										label={pageLanguageContent['PRL144'] ? pageLanguageContent['PRL144'] : ''}
										name='gender_id'
										className='form-control'
										onChange={inputsHandler}
										value={inputField.gender_id}
									>
										<option value=''>{pageLanguageContent['PRL100'] ? pageLanguageContent['PRL100'] : ''}</option>
										{copiriGenderList.length > 0 &&
											copiriGenderList.map((item, i) => (
												<option value={item.id} key={item.id}>
													{item.title}
												</option>
											))}
									</select>
								</Form.Group>
								{validation.error_gender && <p className='formValidationError'>{validation.error_gender}</p>}
							</Col>
						</Row>
					)}
				</ModalBody>
				<ModalFooter>
					<Button variant='primary' onClick={updateProfileName} disabled={disableSubmitButton}>
						{genPageData['GENSAV'] ? genPageData['GENSAV'] : ''}
					</Button>
				</ModalFooter>
			</Modal>
		</>
	);
};
export default EditProfileDateModal;
